import { ServiceSchema } from "@redotech/redo-fulfillment-carrier-common/carrier-service-catalog";
import { CarrierSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import { consolidationCartonLabelVoidIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const cartonLabelVoidOutcomeSchema = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("voided"),
    refundStatus: z.enum(["submitted", "refunded", "not_applicable"]),
  }),
  z.object({ status: z.literal("rejected") }),
  z.object({ status: z.literal("not_voidable"), reason: z.string() }),
  z.object({ status: z.literal("not_found") }),
  z.object({ status: z.literal("internal_shipment") }),
]);
export type CartonLabelVoidOutcome = z.infer<
  typeof cartonLabelVoidOutcomeSchema
>;

const cartonLabelVoidStateSchema = z.object({
  id: consolidationCartonLabelVoidIdFormat.schema,
  redoShipmentId: z.string(),
  status: z.enum([
    "pending",
    "voided",
    "rejected",
    "not_voidable",
    "not_found",
    "internal_shipment",
  ]),
  refundStatus: z.enum(["submitted", "refunded", "not_applicable"]).nullable(),
  reason: z.string().nullable(),
  createdAt: z.date(),
  completedAt: z.date().nullable(),
});
export type CartonLabelVoidState = z.infer<typeof cartonLabelVoidStateSchema>;

export const cartonLabelVoidHistorySchema = cartonLabelVoidStateSchema.extend({
  carrier: CarrierSchema.nullable(),
  service: ServiceSchema.nullable(),
  trackingNumber: z.string().nullable(),
});
export type CartonLabelVoidHistory = z.infer<
  typeof cartonLabelVoidHistorySchema
>;
